const layers = [

  {
    "type": "overlayers",
    "name": "Sobreposições",
    "visible": true,
    "layers": [
      {
        "id": 682,
        "name": "Reservatórios do SAIC",
        "url": "https://produtos.simepar.br/geobarragem/bd/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=bd:sanepar_volume_medio&outputFormat=application/json",
        "url_params": {
          "LAYERS": "forecastdev:customer_subbasin",
          "STYLES": "pgw_polygon_env",
          "ENV": "stroke_color:66B2FF;fill_color:CCE5FF;stroke_width:1.5",
          "VIEWPARAMS": "customer_id:7",
          "CQL_FILTER": "bacid=16"
        },
        "layer_class": "ol.layer.Vector",
        "layer_type": "ol.source.Vector",
        "property_params": {
          "opacity": 1,
          "visible": true,
          "zindex": 4
        },
        "tooltip_params": {
          "KEYS": ["estnome", "data"],
          "FORMAT": "{0}<br>Última leitura: {1}"
        },
        "params": {
          "type": "chart",
          "chart_options": {
            "graph_type": "donut",
            "graph_colors": ["blue", "#3E3E4D"],
            "graph_threshold": [{
              "red": 20,
              "orange": 40,
              "yellow": 60,
              "green": 80,
              "blue": 100
            }],
            "attribute_size": "area_reserv",
            "attribute_values": ["vol_perc", "vol_restante"],
            "intervalScaleValues": [10, 20]
          }
        }
      },
      {
        "id": 694,
        "name": "Reservatórios Atuais",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:sanepar_reservatorio"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": ["sannome"],
          "FORMAT": "Reservatório {0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": true,
          "zindex": 1
        },
        "hide_on_menu": true,
      },
      {
        "id": 663,
        "name": "Bacias dos reservatórios",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:prevflowbysia_subbasin",
          "STYLES": "blue_polygon",
          "cql_filter": "dailocationid in (996,1162,1164)"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "sbsname", "label_title": ""}',
            '{"key": "d1", "label": "Vazão", "suffix": "m³/s"}'
          ],
          "icon_params":{
            "class": "icon-infohidro-bacia",
            "background_color": "#0071B0"
          },
          "FORMAT": "{0} - {1}",
        },
        "property_params": {
          "opacity": 0.5,
          "visible": false,
          "zindex": 1
        }
      },
      {
        "id": 732,
        "name": "Estações de Tratamento de Água (ETAs)",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "layers=bd:sanepar_eta"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "groupingname,locacronymn", "label_title": ""}',
            '{"key": "population", "label": "População atendida", "icon_label":"mdi-account-group-outline", "suffix": "habitantes"}',
            '{"key": "avarageDemand", "label": "Demanda média", "icon_label":"mdi-chart-bubble", "suffix": "habitantes"}',
          ],
          "FORMAT": "{0} - {1}",
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 3
        },
        "icon_params":{
          "class": "icon-infohidro-eta",
          "background_color": "#03A696"
        },
      },
    ]
  },
];

export default layers;
